export const GET_CHALLENGE = 'app-pfj/v2/loginqr/info'
